import useResources from "./use-resources";

const ROOT_PATH = "comptes";

export default function useComptes({ params } = {}) {
  const {
    resources: comptes,
    error,
    isLoading,
    update,
  } = useResources(ROOT_PATH, { params });

  function changeCall(accountId, values) {
    return update(accountId, values, { alternatePath: "/initial-call" });
  }

  function changeSubscription(accountId, values) {
    return update(accountId, values, { alternatePath: "/abonnement" });
  }

  return {
    comptes,
    error,
    isLoading,
    changeCall,
    changeSubscription,
  };
}
